import { Props } from './Background';
export { default } from './Background';
export type Props = Props;
